//https://porch.invisionapp.com/share/N6TFX36ZYMB#/screens/377922035
export const siteColors = {
    darkBlue: '#0F75BC',
    darkBlueRGB: [15, 117, 188],
    mediumBlue: '#86CAF9',
    lightBlue: '#CEEBFF',
    lightGreen: '#86ad82',
    mediumGreen: '#5EAE56',
    darkGreen: '#254522',
    gray: '#F9FAFB',
    darkGray: '#454545',
    mediumGray: '#757575',
    lighterGray: '#CCCCCC',
    lightGray: '#F5F5F5',
    white: '#FFFFFF',
    black: '#252525',
    fastSearchBackground: '#f0f0f0',
    fastSearchBackgroundHover: '#d5d5d5',
    fastSearchIncomplete: '#fff9e5',
    fastSearchDeleted: '#ffe5e5',
    darkRed: '#a94442',
    alertRed: '#f44336',
    darkYellow: '#ebbe00'
};
